export enum TechnicalTerm {
  ADJACENT = "ADJACENT",
  ADJACENT_IN_THE_SAME_ROW = "ADJACENT_IN_THE_SAME_ROW",
  BOARD_EFFECT = "BOARD_EFFECT",
  CONE = "CONE",
  ON_HIT = "ON_HIT",
  ON_ATTACK = "ON_ATTACK",
  STRONGEST = "STRONGEST"
}

export const TechnicalTerms = Object.values(TechnicalTerm)
